import React from 'react';

const SENT_STATUS_BORDER = {
    neutral: '1px solid #D2E0FF',
    'linked-only': '1.5px dotted #1967D2',
    'linked-and-sent': '1.5px solid #34A853',
};

const SENT_STATUS_TITLE = {
    'linked-only': 'Linked to one or more surveys; not yet dispatched. Use Send in Staging to dispatch.',
    'linked-and-sent': 'Linked and dispatched.',
};

export default function StagingRecipientChip({
    recipientId,
    displayName,
    sentStatus = 'neutral',
    onRemove,
    onContextMenu,
}) {
    const border = SENT_STATUS_BORDER[sentStatus] || SENT_STATUS_BORDER.neutral;
    const title = SENT_STATUS_TITLE[sentStatus];

    return (
        <span
            onContextMenu={onContextMenu}
            title={title}
            style={{
                display: 'inline-flex', alignItems: 'center', gap: 4,
                padding: '3px 8px', borderRadius: 12, fontSize: 12,
                background: '#F0F4FF', border,
                color: '#3C4043', whiteSpace: 'nowrap', maxWidth: 200,
            }}
        >
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{displayName || recipientId}</span>
            <button
                onClick={() => onRemove(recipientId)}
                style={{
                    background: 'none', border: 'none', padding: 0, cursor: 'pointer',
                    color: '#5F6368', fontSize: 14, lineHeight: 1, display: 'flex',
                }}
                title="Remove from Staging"
            >&times;</button>
        </span>
    );
}
